const React = require('react');
const {FormWrapper} = require('../../../../../dumb/FormHandlers');
const {ProfileFormInner, schemaPersonalProfile} = require('../../../../../dumb/AdminHelpers/AdminUserRegistration');
const {apiAdminMerchantProfileCreate, apiAdminMerchantProfileUpdate, apiAdminMerchantProfileDelete} = require("../../../../../../api/admin/retailersCreate");
const UserRegistrationFooter = require("../../../../../dumb/AdminHelpers/AdminUserRegistration/components/UserRegistrationFooter");

const addPrefix = (prefix) => (key) => [prefix, key].join('_');

const fields = [
  'full_name',
  'birthdate',
  'country_of_residence',
  'country_of_birth',
  'identity_doc',
  'document_identity',
  'document_address',
];

const holderFields = fields.map(addPrefix('account_holder'));
const directorFields = fields.map(addPrefix('director'));

const handleRawData = (rawData) => {
  const data = {};

  const handleFieldsData = (userData) => (key, i) => {
    const originalKey = fields[i];

    if (['document_identity', 'document_address'].includes(originalKey)) {
      const documentIDs = {
        document_identity: 'identity_doc_data',
        document_address: 'address_doc_data'
      }
      const documentID = documentIDs[originalKey];

      data[key] = userData[documentID] || {};
    } else {
      data[key] = userData[originalKey] || '';
    }
  };

  const companyData = rawData.company || {};
  const profiles = companyData.profiles || [];
  const holderData = profiles.find((el) => ['account_holder', 'director_holder'].includes(el.profile_type));

  data['holder_id'] = holderData.id;

  holderFields.forEach(handleFieldsData(holderData));

  if (holderData.profile_type === 'director_holder') {
    data['holder_is_director'] = true;
  } else {
    const directorData = profiles.find((el) => el.profile_type === 'director');

    data['director_id'] = directorData.id;

    directorFields.forEach(handleFieldsData(directorData));
  }

  return data;
};

module.exports = ({activeUserId, stepsData, stepsCompleted, resetUserData, onFormResult, nextStepDisabled, onNextStep}) => {
  const profileAlreadyCreated = stepsCompleted.personalProfile;

  const {holder_id: holderID, director_id: directorID, ...initialData} = profileAlreadyCreated
    ? handleRawData(stepsData)
    : {};

  return (
    <FormWrapper
      data={initialData}
      schema={schemaPersonalProfile}
      onSubmit={(data) => {
        const fieldsReducer = (acc, next, i) => {
          const originalKey = fields[i];

          if (['document_identity', 'document_address'].includes(originalKey)) {
            const documentIDs = {
              document_identity: 'identity_doc_id',
              document_address: 'address_doc_id'
            };
            const documentID = documentIDs[originalKey];

            acc[documentID] = (data[next] || {}).id;
          } else {
            acc[originalKey] = data[next];
          }

          return acc;
        }

        const defaultHolderData = {account_id: activeUserId, profile_type: 'account_holder'};

        if (profileAlreadyCreated) defaultHolderData['id'] = holderID;

        const holder = holderFields.reduce(fieldsReducer, defaultHolderData);
        const holderDirector = {...holder, profile_type: 'director_holder'};

        const defaultDirectorData = {account_id: activeUserId, profile_type: 'director'};

        if (profileAlreadyCreated) defaultDirectorData['id'] = directorID;

        const director = directorFields.reduce(fieldsReducer, defaultDirectorData);

        const updateQueryBoth = [holder, director];

        if (!profileAlreadyCreated) {
          const requestProps = data.holder_is_director
            ? [holderDirector]
            : updateQueryBoth;

          return Promise.all(requestProps.map(apiAdminMerchantProfileCreate));
        }

        if (initialData.holder_is_director && data.holder_is_director) {
          return apiAdminMerchantProfileUpdate(holderDirector);
        }

        if (!initialData.holder_is_director && !data.holder_is_director) {
          return Promise.all(updateQueryBoth.map(apiAdminMerchantProfileUpdate));
        }

        if (data.holder_is_director && directorID) {
          const removeDirector = apiAdminMerchantProfileDelete({id: directorID});
          const updateHolder = apiAdminMerchantProfileUpdate(holderDirector);
          return Promise.all([removeDirector, updateHolder]);
        }

        if (!data.holder_is_director && !directorID) {
          const createDirector = apiAdminMerchantProfileCreate(director);
          const updateHolder = apiAdminMerchantProfileUpdate(holder);
          return Promise.all([createDirector, updateHolder]);
        }

        return new Promise((res) => res());
      }}
      onResult={profileAlreadyCreated
        ? resetUserData
        : onFormResult
      }
    >
      {(formCtx) => (
        <>
          <ProfileFormInner
            activeUserId={activeUserId}
            formCtx={formCtx}
          />
          <UserRegistrationFooter
            submitBtnProps={{
              text: profileAlreadyCreated ? 'Save' : 'Save & Proceed',
              formCtx
            }}
            nextStepBtnProps={{
              onClick: onNextStep,
              disabled: nextStepDisabled
            }}
          />
        </>
      )}
    </FormWrapper>
  )
}
